//#region src/assets/credit-card-vana.svg
var credit_card_vana_default = "" + new URL("credit-card-vana-DegIdu0B.svg", import.meta.url).href;
//#endregion
export { credit_card_vana_default as default };

//# sourceMappingURL=credit-card-vana.js.map